import axios from 'axios'
const instance = axios.create({
  // baseURL: 'https://dev.bibomart.net/customer_account'
  baseURL: 'https://prod.bibomart.net/customer_account'
});

instance.interceptors.response.use((response) => {
    return response.data
}, error => {
  return Promise.resolve({ error });
  // window.localStorage.setItem('errornetwworkmsg', error);
  // return  window.location.href = '/404.html';
})

export default instance;